export const Pricing = () => (
  <div className="min-h-screen bg-white py-16">
    <div className="max-w-4xl mx-auto px-6">
      <h1 className="text-4xl font-semibold text-[#1A1A1A] mb-8 text-center font-['Outfit']" data-testid="pricing-title">Pricing</h1>
      <div className="max-w-md mx-auto bg-white border border-[#E5E7EB] rounded-2xl p-8">
        <h2 className="text-2xl font-medium text-[#1A1A1A] mb-4 font-['Outfit']">List Your Property</h2>
        <div className="text-5xl font-semibold text-[#005B99] mb-2 font-['Outfit']">R950</div>
        <p className="text-[#6B7280] mb-6">Valid for 3 months</p>
        <ul className="space-y-3 text-[#6B7280]">
          <li>✓ Unlimited enquiries</li>
          <li>✓ No booking commission</li>
          <li>✓ Calendar management</li>
          <li>✓ Photo & video uploads</li>
          <li>✓ Verified badge</li>
        </ul>
      </div>
    </div>
  </div>
);
